<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <div style="overflow-x: scroll">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width: 40px" align="center">No</th>
            <th style="min-width: 40px" align="center">Judul</th>
            <th style="min-width: 40px" align="center">Penerbit</th>
            <th style="min-width: 40px" align="center">Tahun</th>
            <th style="min-width: 200px" align="center">Karya Tulis</th>
            <th style="min-width: 200px" align="center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, n) in all" :key="item.id">
            <td>{{ n+1 }}</td>
            <td>{{item.judul}}</td>
            <td>{{item.penerbit}}</td>
            <td>{{item.tahun}}</td>
            <td v-if="item.ext_upload_karya != null"><a :href="base + 'storage/docs/karya_tulis_' + item.id_karya + '.' + item.ext_upload_karya" target="_blank">lihat dokumen</a></td>
            <td v-else>-</td>
            <td><a class="btn btn-danger" @click="() => { deleteData(item.id_karya) }">hapus</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('JUDUL_KARYA')" :class="{'form-group': true, 'has-error': errors.has('judul')}">
        <label class="col-md-3"><span class="required-label">*</span>Judul Karya Tulis</label>
        <div class="col-md-6">
          <input
            type="text"
            name="judul"
            placeholder="Judul Karya Tulis"
            class="form-control"
            maxlength="255"
            v-model="model.judul"
            v-validate="isExist('JUDUL_KARYA') ? 'required' : ''"
          >
          <span v-show="errors.has('judul')" class="error-label">Isi Judul Karya Tulis</span>
        </div>
      </div>
      <div v-show="isExist('PENERBIT')" :class="{'form-group': true, 'has-error': errors.has('penerbit')}">
        <label class="col-md-3"><span class="required-label">*</span>Penerbit</label>
        <div class="col-md-6">
          <input
            type="text"
            name="penerbit"
            placeholder="Penerbit"
            class="form-control"
            maxlength="125"
            v-model="model.penerbit"
            v-validate="isExist('PENERBIT') ? 'required' : ''"
          >
          <span v-show="errors.has('penerbit')" class="error-label">Isi Penerbit</span>
        </div>
      </div>
      <div v-show="isExist('TAHUN')" :class="{'form-group': true, 'has-error': errors.has('tahun')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun Terbit</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tahun"
            placeholder="Tahun Terbit"
            class="form-control"
            maxlength="8"
            v-model="model.tahun"
            v-validate="isExist('TAHUN') ? 'required' : ''"
          >
          <span v-show="errors.has('tahun')" class="error-label">Isi Tahun Terbit</span>
        </div>
      </div>
      <div v-show="isExist('KARYA_TULIS')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>File Karya Tulis</label>
        <div class="col-md-6">
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="docEndPointKaryaTulis"
              :headers="header"
              :auto-upload="false"
              name="upload_karya"
              :data="dataUpload"
              :on-change="handleChange"
              :on-error="handleError"
              :on-success="handleSuccess"
              :limit="1"
              :on-exceed="handleExceed"
              :before-upload="beforeDocsUpload"
              :file-list="model.upload_karya_list"
              drag>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
              <div class="el-upload__tip" slot="tip"><strong>Format pdf dan tidak boleh lebih dari 1 MB</strong></div>
            </el-upload>
        </div>
      </div>
    </form>
    <div class="alert alert-success">
      <p>Tekan tombol tambah untuk menambahkan karya tulis</p>
      <button class="btn btn-default" style="margin-top: 20px;" @click="sendData">Tambah</button>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL, base } from '@/api/data'

export default {
  data () {
    return {
      init: false,
      all: [],
      loading: false,
      model: {
        judul: null,
        penerbit: null,
        tahun: null,
        upload_karya: [],
        upload_karya_list: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    base () {
      return base
    },
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar, ...this.model}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointKaryaTulis () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_karya_tulis'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(19).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        resolve(true)
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let keryaTulisUploaded = this.model.upload_karya.length > 0
              !keryaTulisUploaded && this.isExist('KARYA_TULIS') ? reject({message: 'belum ada file karya tulis'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    sendData () {
      this.validateForm()
        .then(valid => {
          this.$refs.upload.submit()
        })
        .catch(e => {
          this.flash(e.message, 'error')
          scroll(0, 0)
        })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 19)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.init = true
      }
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.model.judul = null
        this.model.penerbit = null
        this.model.tahun = null
        this.model.upload_karya = []
        this.model.upload_karya_list = []
        this.all.push({
          id_karya: 'test',
          judul: 'test',
          penerbit: 'test',
          tahun: 'test',
          ext_upload_karya: 'test'
        })
        alert('upload sukses')
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleSuccess (res, file) {
      this.model.judul = null
      this.model.penerbit = null
      this.model.tahun = null
      this.model.upload_karya = []
      this.model.upload_karya_list = []
      this.getUploadKarya(res.data.id_karya)
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    handleChange (file, fileList) {
      this.model.upload_karya = [{name: file.name}]
    },
    getData () {
      this.loading = true
      api.get('/v2/data_karya_tulis/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.all = responseData.data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getUploadKarya (idKarya) {
      api.get('/v2/data_karya_tulis/upload_karya/' + idKarya)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.getData()
          }
        })
    },
    deleteData (idKarya) {
      if (process.env.NODE_ENV !== 'test') {
        api.delete('/v1/data_karya_tulis/' + idKarya)
          .then(response => {
            let responseData = response.data
            if (responseData.success) {
              this.getData()
            }
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataKaryaTulis.vue